import { request } from '@umijs/max';

export async function queryAdminList(
  params?: any,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/admin', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function login(body: any, options?: { [key: string]: any }) {
  return request<any>('/api/v1/admin/login', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function queryUserInfo(options?: { [key: string]: any }) {
  return request<any>('/api/v1/admin/info', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function addAdmin(
  body: API.AdminInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/admin', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function updateAdmin(
  id: number,
  body: { [key: string]: any },
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/admin/${id}`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

export async function removeAdmin(
  params: { id: number },
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/admin/${params.id}`, {
    method: 'DELETE',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
